import type { FaireProductEntity } from "../../entity_types/product";

export const p_w7sxatuqfk: FaireProductEntity = {
  token: "p_w7sxatuqfk",
  type: "product",
  name: "Tiny Tahitian Keshi Choker (Bestseller) ",
  brandName: "Keshi Co",
  imageUrl:
    "https://cdn.faire.com/fastly/8e2895578655c2a141dd54e42b560f242eb8bbefee1d944d7570c7cafc98cfa1.jpeg",
  priceDollars: 30,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/65de55d61f2157e94627836176b1b34c246c1571b4c9ba2895598bf9b7500744.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
